import { settingsApi } from '@/api';
import { ErrorNotificationIcon } from '@/assets/icons';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useGetInvoice = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: settingsApi.getInvoice,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
        },
        onError: (error) => {
            console.error('Error complain profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: t('send_request_error')
            });
        },
    });

    return mutation;
};
